import { render } from "./KSClusterAction.vue?vue&type=template&id=50538376&scoped=true"
import script from "./KSClusterAction.vue?vue&type=script&lang=js"
export * from "./KSClusterAction.vue?vue&type=script&lang=js"

import "./KSClusterAction.vue?vue&type=style&index=0&id=50538376&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50538376"]])

export default __exports__